import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    actionButton: {
      marginRight: theme.spacing(2),
      padding: 0,
    },
  })
);
